const isMobileAppView = () => navigator.userAgent.match(/MobileAppWebView/i);

export default isMobileAppView;